export default __webpack_public_path__ + "static/media/superhost-subscription.9ba70b99.svg";